<template>
  <div class="product-main-body -row-type">
    <div class="product-main-body__wrapper">
      <div class="product-main-body__lists-wrapper" ref="wrapper">
        <template v-if="false">
          <div class="product-row-type__year-choose scrollObj" @click="resort">
            <p>year</p>
          </div>
        </template>
        <div class="wrapper__row-inner">
          <div
            class="row__item scrollObj"
            :class="{
              hoverShow: !$bowser.mobile
            }"
            v-for="product in products"
            :key="product.id"
            :data-cover="product && product.covers && product.covers['0']"
            @mouseenter="onMouseEnter"
          >
            <div class="item__inner" tag="div" @click="onJump(product)">
              <template v-if="$bowser.mobile">
                <p v-if="Number(product.type_id) === 6" class="mobile__inner__name">
                  {{ product.name.cn }} <br />{{ product.name.en }}
                </p>
                <p v-else class="mobile__inner__name --tow-line">
                  {{ product.name.cn }} | {{ product.name.en }}
                </p>
                <div
                  class="mobile__inner__row"
                  :class="[
                    product.location.cn ? 'pos-bettwen' : 'pos-end',
                    Number(product.type_id) === 6 ? '' : 'not-product'
                  ]"
                >
                  <p v-if="product.location.cn">
                    {{ product.location.cn }} | {{ product.location.en }}
                  </p>
                  <p>{{ product.year }}年</p>
                </div>
              </template>
              <template v-else>
                <p>{{ product.name.cn }} | {{ product.name.en }}</p>
                <p class="item__location" v-if="product.location.cn">
                  {{ product.location.cn }} | {{ product.location.en }}
                </p>
                <p v-if="product.year">{{ product.year }}年</p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!$bowser.mobile"
      class="wrapper__fixed-cover scrollObj"
      data-immediate="1"
      ref="compareWrapper"
      :class="{
        'pos-top': isFullNotScreen,
        'pos-bottom': !isFullNotScreen
      }"
    >
      <div class="cover__inner">
        <img src="" alt="" ref="imgBox" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-list-type-row',
  props: {
    lists: {
      type: Array,
      default: null,
    },
  },
  data() {
    const that = this;
    return {
      products: that.lists,
      imgLoading: true,
      imgLoadingError: null,
      isTriggerScroll: false,
      isFullNotScreen: false,
    };
  },
  watch: {
    lists: {
      handler(val) {
        this.products = val;
        this.firstCoverInit();
      },
      immediate: true,
    },
  },
  mounted() {
    const that = this;
    that.$nextTick(() => {
      if (!that.$bowser.mobile) {
        window.addEventListener('scroll', that.onScroll);
      }
    });
    that.$parent.$on('notFullScreen', () => {
      that.isFullNotScreen = true;
    });
  },
  destroyed() {
    if (this.isTriggerScroll) {
      window.removeEventListener('scroll', this.onScroll);
    }
  },
  methods: {
    firstCoverInit() {
      const that = this;
      that.$nextTick(() => {
        const { covers } = that.products['0'];
        const src = covers ? covers['0'] : null;
        const p = that.loadImg(src);
        p.then((info) => {
          const classShape = info.width >= info.height ? '-across' : '-vertical';
          that.$refs.imgBox.classList.remove('-vertical', '-across');
          that.$refs.imgBox.classList.add(classShape);
          that.$refs.imgBox.setAttribute('src', src);
        })
          .catch((e) => {
            that.imgLoadingError = e;
          })
          .finally(() => {
            that.imgLoading = false;
          });
        if (!that.$bowser.mobile) {
          window.addEventListener('scroll', that.onScroll);
        }
      });
    },
    onMouseEnter(el) {
      const that = this;
      that.imgLoading = true;
      const target = el.currentTarget;
      const src = target.dataset.cover;
      const p = that.loadImg(src);
      p.then((info) => {
        const classShape = info.width >= info.height ? '-across' : '-vertical';
        that.$refs.imgBox.classList.remove('-vertical', '-across');
        that.$refs.imgBox.classList.add(classShape);
        that.$refs.imgBox.setAttribute('src', src);
      })
        .catch((e) => {
          that.imgLoadingError = e;
        })
        .finally(() => {
          that.imgLoading = false;
        });
    },
    onMouseLeave() {
      const that = this;
      that.imgLoadingError = null;
      that.imgLoading = false;
      that.$refs.imgBox.className = '';
      that.$refs.imgBox.setAttribute('src', '');
    },
    loadImg(src) {
      const p = new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve(img);
        };
        img.onerror = (err) => {
          reject(err);
        };
        img.src = src;
      });
      return p;
    },
    onScroll() {
      const that = this;
      that.isTriggerScroll = true;
      if (that.$refs.wrapper) {
        const bcr = that.$refs.wrapper.getBoundingClientRect();
        const compareBcr = that.$refs.compareWrapper.getBoundingClientRect();
        if (compareBcr.bottom > bcr.bottom) {
          that.$refs.compareWrapper.classList.add('move');
          that.$refs.compareWrapper.querySelector(
            '.cover__inner',
          ).style.cssText = `bottom:${compareBcr.bottom - bcr.bottom}px`;
        } else {
          that.$refs.compareWrapper.classList.remove('move');
          that.$refs.compareWrapper.querySelector('.cover__inner').style.cssText = 'bottom:0px';
        }
      }
    },
    resort(el) {
      const target = el.currentTarget;
      if (target.classList.contains('actived')) {
        target.classList.remove('actived');
      } else {
        target.classList.add('actived');
      }
    },
    onJump(item) {
      if (Number(item.type_id) === 6) {
        window.location.href = item.link;
      } else {
        this.$router.push({
          path: `/product/${encodeURIComponent(item.name.en)}/${item.id}`,
        });
      }
    },
  },
};
</script>

<style></style>
